import { Box, Tooltip } from "@mui/material";
import TypographyMultilineEllipsis from "../TypographyMultilineEllipsis";

interface Props {
  label: string;
}

const MultilineGridHeader = ({ label }: Props) => {
  return (
    <Tooltip arrow title={label} placement="bottom" disableInteractive enterDelay={500}>
      <Box>
        <TypographyMultilineEllipsis
          maxLines={2}
          typographyProps={{ variant: "caption", color: "textSecondary", sx: { whiteSpace: "normal" } }}
        >
          {label}
        </TypographyMultilineEllipsis>
      </Box>
    </Tooltip>
  );
};

export default MultilineGridHeader;
